import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2440f71f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label" }
const _hoisted_2 = ["value"]

import {computed, ref} from 'vue'

  
  const __default__ = {
    name: 'RadioInput'
  }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {
      required: true,
      type: Object
    },

    label: {
      required: true,
      type: String
    },

    value: {
      required: true,
      type: Object
    },

    knownAnswer: {
      required: false,
      type: Boolean,
      default: () => true
    }
  },
  emits: {
    'update:modelValue': (value) => {
      return !!value
    }
  },
  setup(__props, { emit }) {

const props = __props;

  

  const knownAnswer = ref(props.knownAnswer)

  

  const checked = computed(() => {
    if (!props.modelValue) {
      return false
    }

    return props.value.id === props.modelValue.id
  })

  const resource = computed({
    get() {
      return props.modelValue
    },

    set(value) {
      emit('update:modelValue', value)
    }
  })

  const classObject = computed(() => {
    return {
      'is-active': !!checked.value,
      'has-known-answer': knownAnswer.value
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["radio-input", _unref(classObject)])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(props.label), 1),
    _withDirectives(_createElementVNode("input", {
      ref: "input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(resource) ? (resource).value = $event : null)),
      class: "input",
      type: "radio",
      value: props.value
    }, null, 8, _hoisted_2), [
      [_vModelRadio, _unref(resource)]
    ])
  ], 2))
}
}

})